<template lang="html">
  <v-dialog
  v-model="dialog"
  width="500"
  >
  <template v-slot:activator="{ on }">
    <v-btn
    style="float:right"
    color="primary"
    dark
    v-on="on"
    >
    Anmelden
  </v-btn>
</template>

<v-toolbar class="pt-5 blue darken-4">
  <v-toolbar-title class="white--text"><h4>Anmelden</h4></v-toolbar-title>
</v-toolbar-items>
</v-toolbar>
<v-card>
  <v-card-text class="pt-4">
    <div>
      <v-form v-model="valid" ref="form">
        <v-text-field
        label="E-mail"
        v-model="email"
        required
        ></v-text-field>
        <div v-if="email == '' && showErrors" style="color:red">
          {{ lang.felhasznalonev_megadasa_kotelezo }}
        </div>
        <v-text-field
        label="Passwort"
        v-model="password"
        :append-icon="e1 ? 'visibility' : 'visibility_off'"
        :append-icon-cb="() => (e1 = !e1)"
        :type="e1 ? 'password' : 'text'"
        required
        ></v-text-field>
        <v-checkbox v-model="isAdmin" label="admin"></v-checkbox>
        <div v-if="password.length < 6 && showErrors" style="color:red">
          {{ lang.a_jelszonak_minimum_hat_karakternek_kell_lennie }}
        </div>
        <div>{{response}}</div>
        <v-layout justify-space-between>
          <v-btn @click="submit" >Go</v-btn>
        </v-layout>
      </v-form>
    </div>
  </v-card-text>
</v-card>
</v-dialog>
</template>

<script>
import axios from 'axios';
   export default {
     data(){
       return {
         isAdmin: false,
         dialog: false,
         valid: false,
         showErrors: false,
         password: '',
         email: '',
         response: '',
         e1: 1,
       }
     },
     methods: {
       async submit () {
         this.showErrors = true
         if (this.password.length < 6 || this.email == '') return
         axios.post('signup.php', {password: this.password, email: this.email, isAdmin: this.isAdmin})
         .then(response => {
           this.showErrors = false
           if (response.data.success) {
             this.response = this.lang.muvelet_sikeresen_vegrehajtva
             this.password = ''
             this.email = ''
             this.isAdmin = false
             setTimeout(function(){
               this.dialog = false
               this.$emit('itemCreated')
             }.bind(this), 500);
           } else {
             this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
           }
         })
         .catch(e => {
           this.response = this.lang.hiba_tortent_a_muvelet_vegrehajtasa_soran
         })
       }
     },
     watch: {
       dialog(val){
           if (!val) {
             this.password = ''
             this.email = ''
             this.response = ''
             this.showErrors = false
           }
       }
     }
   }
 </script>
